import servicesUtils from "../../../utils/servicesUtils";
var resolveReminder = function resolveReminder(patientUid, reminderId) {
  return servicesUtils.postService("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/resolve/"));
};
export default resolveReminder;